import React, { useEffect, useState } from "react";
import { Col, Form, Input, Row, Select, Switch, Tooltip, Image, Checkbox } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import uuid from "react-uuid";
import { putRequest } from "../../api/http";
import userServiceApi from "../../api/userServiceApi";
import deleteIcon from "../../assets/images/deleteIcon.svg";
import UserIcon from "../../assets/images/icons/userLogo.svg";
import { inputFieldCharLimit } from "../../config";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";


function PartnerDetailsForm({
  partnerData,
  partnerTypes,
  fetchPartnerDetails,
  setShowForm,
  handleResetWallpaper,
  setLoading,
}) {
  const [form] = Form.useForm();
  const [imageFile, setImageFile] = useState();
  const [wallpaperFile, setWallpaperFile] = useState();
  const [media, setMedia] = useState({});
  const [wallpaper, setWallpaper] = useState({});
  const [endUserWallpaper, setEndUserWallpaper] = useState(
    partnerData?.wallpaperToggle
  );
  const [selectedPartnerType, setSelectedPartnerType] = useState();

  useEffect(() => {
    form.resetFields();
  }, [partnerData]);


  const handleImageUpload = (event) => {
    const file = event.target.files?.[0];
    if (!file || file.size >= 2e6) {
      toast.error("File size should not exceed 2MB");
      return;
    }

    const unique_ID = uuid();
    const fileNameArray = file.name.split(".");
    const fileExtension = fileNameArray.pop();
    const fileName = fileNameArray.join(".");
    const fileType = file.type.split("/")[0];
    const newFile = new File(
      [file.slice()],
      `${unique_ID}_${fileName}.${fileExtension}`,
      { type: file.type }
    );

    setMedia({
      mediaType: fileType === "image" ? "IMAGE" : null,
      mediaProperty: {
        id: unique_ID,
        name: fileName,
        extension: fileExtension,
      },
    });
    setImageFile(newFile);
    form.setFieldsValue({ media: newFile });
  };

  const handleWallpaperUpload = (event) => {
    const file = event.target.files?.[0];
    if (!file || file.size >= 200e6) {
      toast.error("File size should not exceed 200MB");
      return;
    }
    if (file.type.split("/")[0] !== "image") {
      toast.error("Please select an image file");
      return;
    }

    const unique_ID = uuid();
    const fileNameArray = file.name.split(".");
    const fileExtension = fileNameArray.pop();
    const fileName = fileNameArray.join(".");
    const newFile = new File(
      [file.slice()],
      `${unique_ID}_${fileName}.${fileExtension}`,
      { type: file.type }
    );

    setWallpaper({
      mediaType: "IMAGE",
      mediaProperty: {
        id: unique_ID,
        name: fileName,
        extension: fileExtension,
      },
    });
    setWallpaperFile(newFile);
    form.setFieldsValue({ wallpaper: newFile });
  };

  const handleSubmit = async (values) => {
    setLoading(true);
    const formData = new FormData();
    const address = values.address.replace(/(\r\n|\n|\r)/g, " ");

    const payload = {
      ...values,
      address,
      endUserPageDescription: values?.endUserPageDescription || '',
      wallpaper,
      wallpaperToggle: endUserWallpaper,
      partnerTypeId: values.partnerTypeId,
      partnerSponsorsSliderTitle: values?.partnerSponsorsSliderTitle || '',
    };

    if (Object.keys(media).length > 0) {
      payload.media = media;
    }


    if (imageFile) formData.append("file", imageFile);
    if (wallpaperFile) formData.append("wallpaper", wallpaperFile);

    const json = JSON.stringify(payload);
    const blob = new Blob([json], { type: "application/json" });
    formData.append("partnerInput", blob);

    try {
      const response = await putRequest(
        userServiceApi.partnerDetails(),
        formData
      );
      if (response) {
        toast.success("Partner Details Updated Successfully");
        fetchPartnerDetails();
        setShowForm(false);
        sessionStorage.setItem("OrgImage", response?.mediaLink);

      }
    } catch (error) {
      toast.error("Failed to update partner details");
    }
    setLoading(false);
  };

  return (
    <Form
      form={form}
      id="partnerDetailsForm"
      className="profile-form"
      onFinish={handleSubmit}
      autoComplete="off"
      initialValues={{
        ...partnerData,
        wallpaperToggle: partnerData?.wallpaperToggle,
      }}
    >

      <div className="partnerInfoRow">
        <div className="partnerInfoCol"><label>Partner Name</label></div>
        <div className="partnerInfoCol">
          <Form.Item name="name" colon={false}>
            <Input placeholder="Partner Name" disabled />
          </Form.Item></div>
      </div>
      
      <div className="partnerInfoRow">
        <div className="partnerInfoCol"><label>Logo</label></div>
        <div className="partnerInfoCol">
          <Form.Item
            name="mediaLink"
            colon={false}
            className="experienceImg"
            rules={[{ required: true, message: "Logo is required" }]}
          >
            <div>
              <img
                src={
                  imageFile
                    ? URL.createObjectURL(imageFile)
                    : partnerData?.mediaLink || UserIcon
                }
                className="form-image"
                alt="logo"
              />
              {/* <Tooltip title="Upload image with size lesser than 2.5MB. Recommended image dimensions: 1280x720 pixels"> */}
                <label className="fileUploadBtn">
                  Upload Image
                  <input onChange={handleImageUpload} type="file" />
                </label>
              {/* </Tooltip> */}
              <Tooltip title="Recommended image size: 1280×720 pixels">
                <ExclamationCircleOutlined
                  style={{ marginLeft: 8, cursor: "pointer" }}
                />
              </Tooltip>
            </div>
          </Form.Item>
        </div>
      </div>
      <div className="partnerInfoRow">
        <div className="partnerInfoCol"><label>Address</label></div>
        <div className="partnerInfoCol">
          <Form.Item name="address" colon={false}>
            <Input.TextArea
              rows={5}
              maxLength={200}
              showCount
              placeholder="Address"
            />
          </Form.Item>
        </div>
      </div>
      <div className="partnerInfoRow">
        <div className="partnerInfoCol"><label>Mobile Number</label></div>
        <div className="partnerInfoCol">
          <Form.Item
            name="mobileNumber"
            colon={false}
            
              rules={[
              { required: true, message: "Mobile number is required" },
              {
                pattern: /^\+[1-9]\d{6,14}$/,
                message: "Enter a valid mobile number",
              },
            ]}
          >
           
             <PhoneInput
                            className="otp-phone-input otp-input"
                            defaultCountry="GB"
                            placeholder="Enter mobile number"
                            focusInputOnCountrySelection
                            international
                          />
          </Form.Item>
        </div>
      </div>
      <div className="partnerInfoRow">
        <div className="partnerInfoCol"><label>Site name</label></div>
        <div className="partnerInfoCol">
          <Form.Item name="siteName" colon={false} style={{marginBottom: 0}}> 
            <Input placeholder="Site name" maxLength={inputFieldCharLimit} />
          </Form.Item>
          <Form.Item
            name="showSiteName"
            valuePropName="checked"
            initialValue={true}
            colon={false}
            className="showSiteNameCheckbox"
          >
            <Checkbox>
              The site title and description should be displayed in the Organization login page.
            </Checkbox>
          </Form.Item>

        </div>
      </div>
      {/* <div className="partnerInfoRow">
        <div className="partnerInfoCol"><label>Membership Ad Title</label></div>
        <div className="partnerInfoCol">
          <Form.Item
            name="membershipAdTitle"
            colon={false}
          >
            <Input
              placeholder="Membership Title"
              maxLength={inputFieldCharLimit}
            />
          </Form.Item>
        </div>
      </div> */}
      {/* <div className="partnerInfoRow">
        <div className="partnerInfoCol"><label>Membership Ad description</label></div>
        <div className="partnerInfoCol">
          <Form.Item
            name="membershipAdDescription"
            colon={false}
          >
            <Input.TextArea
              rows={5}
              maxLength={500}
              showCount
              placeholder="Enter description"
            />
          </Form.Item>
        </div>
      </div> */}
      {/* <div className="partnerInfoRow">
        <div className="partnerInfoCol"><label>Membership link</label></div>
        <div className="partnerInfoCol">
          <Form.Item
            name="membershipLink"
            colon={false}
          >
            <Input
              placeholder="Membership Link"
              maxLength={inputFieldCharLimit}
            />
          </Form.Item>
        </div>
      </div> */}
      <div className="partnerInfoRow">
        <div className="partnerInfoCol"><label>Organisation login description</label></div>
        <div className="partnerInfoCol">
          <Form.Item
            name="description"
            colon={false}
          >
            <Input.TextArea
              rows={5}
              maxLength={500}
              showCount
              placeholder="Enter description"
            />
          </Form.Item>
        </div>
      </div>
      <div className="partnerInfoRow">
        <div className="partnerInfoCol"><label>Find out more description</label></div>
        <div className="partnerInfoCol">
          <Form.Item
            name="endUserPageDescription"
            colon={false}
          >
            <Input.TextArea
              rows={5}
              maxLength={200}
              showCount
              placeholder="Enter description"
            />
          </Form.Item>
        </div>
      </div>

      <div className="partnerInfoRow">
        <div className="partnerInfoCol"><label>Find out more link</label></div>
        <div className="partnerInfoCol">
          <Form.Item name="website" colon={false}>
            <Input placeholder="Website URL" maxLength={inputFieldCharLimit} />
          </Form.Item>
        </div>
      </div>

      <div className="partnerInfoRow">
        <div className="partnerInfoCol"><label>Wallpaper</label></div>
        <div className="partnerInfoCol">
          <Form.Item
            name="wallpaper"
            colon={false}
            className="wallpaperImg"
          >
            <div className="wallpaper-form-item">
              <div className="wallpaper-item">
                {wallpaperFile || partnerData?.wallpaper ? (
                  <Image
                    src={
                      wallpaperFile
                        ? URL.createObjectURL(wallpaperFile)
                        : partnerData?.wallpaper || UserIcon
                    }
                    className="form-image wallpaper"
                    alt="wallpaper"
                    preview={false}
                    style={{ height: wallpaperFile ? '' : 'auto' }}
                  />
                ) : (<span>No image</span>)}
              </div>
              <div className="wallpaper-actions">
                {/* <Tooltip title="Upload image with size less than 200MB. Recommended image dimensions: 1280x720 pixels"> */}
                  <label className="fileUploadBtn">
                    Upload Image
                    <input type="file" onChange={handleWallpaperUpload} />
                  </label>
                {/* </Tooltip> */}
                <div>
                  <div>
                    <Tooltip title="Recommended image size: 1280×720pixels">
                      <ExclamationCircleOutlined
                        style={{ marginLeft: 8, cursor: "pointer" }}
                      />
                    </Tooltip>
                  </div>
                  {wallpaperFile || partnerData?.wallpaper ? (
                    <div className="delete-icon-container">
                      <img
                        alt="delete icon"
                        src={deleteIcon}
                        className="deleteIcon"
                        onClick={handleResetWallpaper}
                      />
                    </div>
                  ) : null}
                </div>

              </div>
            </div>
          </Form.Item>
        </div>
      </div>

      {/* <div className="partnerInfoRow">
        <div className="partnerInfoCol"><label>Wallpaper for website</label></div>
        <div className="partnerInfoCol">
          <Form.Item
            name="wallpaperToggle"
            colon={false}
          >
            <Switch
              className="wallpaper-switch"
              defaultChecked={partnerData?.wallpaperToggle}
              onChange={(checked) => setEndUserWallpaper(checked)}
            />
          </Form.Item>
        </div>
      </div> */}
      <div className="partnerInfoRow">
        <div className="partnerInfoCol"><label>Partner type</label></div>
        <div className="partnerInfoCol">
          <Form.Item name="partnerTypeId" colon={false}>
            <Select
              placeholder="Select Partner Type"
              value={selectedPartnerType}
              onChange={(value) => setSelectedPartnerType(value)}
              disabled={true}
              readOnly={true}
            >
              {partnerTypes.map((partner) => (
                <Select.Option key={partner.id} value={partner.id}>
                  {partner.displayName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </div>
      </div>

      <div className="partnerInfoRow">
        <div className="partnerInfoCol"><label>Sponsors carousel name</label></div>
        <div className="partnerInfoCol">
          <Form.Item
            name="partnerSponsorsSliderTitle" colon={false}
            rules={[{ required: true, message: "Sponsors carousel name is required" }]}>
            <Input placeholder="Enter sponsors carousel name" maxLength={40} />
          </Form.Item>
        </div>
      </div>
    </Form>
  );
}

export default PartnerDetailsForm;